import { ACCOUNT_ID } from 'hooks/queryParams/useSelectedAccountId';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage';
import { ENTITY } from '../config/routes/entity';

export const PICKER_ENTITY = 'pickerEntity';

export const useEntityPickerType = queryParamHookFactory(PICKER_ENTITY, {
    defaultValue: ENTITY.CAMPAIGN,
    persist: PERSISTENCE_TYPE.MEMORY,
    dependencies: {
        queryParams: [ACCOUNT_ID],
    },
});
